/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutActionMetadata } from './rolloutActionMetadata';
import { RolloutNotificationDetails } from './rolloutNotificationDetails';
import { RolloutActionType } from './rolloutActionType';


export interface RolloutNotificationActionResponse { 
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
    type?: RolloutActionType;
    /**
     * Name of the notifications.
     */
    notification_name?: string;
    notification?: RolloutNotificationDetails;
    metadata?: RolloutActionMetadata;
}
export namespace RolloutNotificationActionResponse {
}


